import type { WkDataTableColumnBaseDefinition } from "@components/data-table/data-table.types";

export abstract class WkDataTableColumn<TColumnDefinition extends WkDataTableColumnBaseDefinition = WkDataTableColumnBaseDefinition> {
    private _definition?: TColumnDefinition;

    protected abstract getDefinitionInfo(): TColumnDefinition;

    protected createDefinition(): TColumnDefinition {
        return this.getDefinitionInfo();
    }

    public get definition(): TColumnDefinition {
        return (this._definition ??= this.createDefinition());
    }
}
